import React, { ReactNode } from 'react'
// importando hooks
import { useEffect, useState, useCallback } from 'react'
// importando estilização da Pagina
import style from './SliderCarousel.module.css'
import { StyledSliderCarousel } from './StyledSliderCarousel'

// Importando icones
import icons from '../../../../img/icons/icons'
// importando Botões
import { ButtonIndicator } from '../../buttons/indicator/ButtonIndicator'




interface ISliderCarousel {
    children: ReactNode[];
}

export const Slider: React.FC<ISliderCarousel> = ({ children }) => {

    const carousel = React.useRef<HTMLDivElement | null>(null);
    const handleLeftClick = (e: any) => {
        e.preventDefault();
        if (null !== carousel.current) {
            carousel.current.scrollLeft -= (carousel.current.offsetWidth);
        }
    };
    const handleRigthClick = (e: any) => {
        e.preventDefault();
        if (null !== carousel.current) {
            carousel.current.scrollLeft += (carousel.current.offsetWidth);
        }
    };

    const changeIndicatorClick = useCallback((num: number) => {
        var width = 0
        if (null !== carousel.current)
            width = (carousel.current.offsetWidth)
        switch (num) {
            case 1:
                if (null !== carousel.current)
                    carousel.current.scrollLeft = 0;
                break;
            case 2:
                if (null !== carousel.current)
                    carousel.current.scrollLeft = width;
                break;
            case 3:
                if (null !== carousel.current)
                    carousel.current.scrollLeft = width * 2;
                break;
            default:
                if (null !== carousel.current)
                    carousel.current.scrollLeft = width + (width * (num - 2));
                break;

        }

    }, []);
    // Rolagem automatica
    useEffect(() => {
        if (!children || children.length <= 1) return;

        const timer = setInterval(() => {
            if (!carousel.current) return;
            
            const scrollPos = carousel.current.scrollLeft;
            const itemWidth = carousel.current.offsetWidth;
            
            if (itemWidth === 0) return;

            const currentIndex = Math.round(scrollPos / itemWidth);
            const nextIndex = (currentIndex + 1) % children.length;
            
            changeIndicatorClick(nextIndex + 1);
        }, 5000);

        return () => clearInterval(timer);
    }, [children.length, changeIndicatorClick]);

    const [isDragging, setIsDragging] = useState(false);
    const [startPos, setStartPos] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e: React.MouseEvent) => {
        setIsDragging(true);
        setStartPos(e.clientX);
        if (carousel.current) {
            setScrollLeft(carousel.current.scrollLeft);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e: React.MouseEvent) => {
        if (!isDragging || !carousel.current) return;
        e.preventDefault();
        const x = e.clientX;
        const walk = (x - startPos) * 4; // the *3 is the fastness factor
        carousel.current.scrollLeft = scrollLeft - walk;
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        setIsDragging(true);
        setStartPos(e.touches[0].clientX);
        if (carousel.current) {
            setScrollLeft(carousel.current.scrollLeft);
        }
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        if (!isDragging || !carousel.current) return;
        e.preventDefault();
        const x = e.touches[0].clientX;
        const walk = (x - startPos) * 4; // the *3 is the fastness factor
        carousel.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <StyledSliderCarousel>
            <div className={style.SliderCarousel}>

                <button className={style.ArrowLeftControl} onClick={handleLeftClick}><img src={icons.slidLeft} alt={"Scroll Left"}></img></button>
                <button className={style.ArrowRigthControl} onClick={handleRigthClick}><img src={icons.slidRight} alt={"Scroll Rigth"}></img></button>
                {/* Wrapper vai receber a rolagem overflow*/}
                <div className={style.GalleryWrapper} >
                    {/* Gallery vai receber os items*/}
                    <div className={style.Gallery} ref={carousel}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        onMouseMove={handleMouseMove}
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                        onTouchMove={handleTouchMove}>
                        {children.map((child, index) => (
                            <div
                                key={index}
                                className={style.BannerItem}
                            >
                                {child}
                            </div>
                        ))}
                    </div>
                </div>
                <div className={style.Indicators}>
                    {
                        children.map((child, index) => (
                            <ButtonIndicator
                                key={index}
                                id={index + 1}
                                click={() => changeIndicatorClick(index + 1)}
                            />
                        ))
                    }
                </div>
            </div>
        </StyledSliderCarousel>

    )
}
